import React, { useState, useEffect } from 'react';
import Spinner from '../../Spinner';
import { DataGrid } from '@mui/x-data-grid';
import { useSensorDataContext } from '../../../contexts/SensorDataContext';
import rawsIcon from '../../../assets/icons/raws-icon-colored.png';
import './RAWS.scss';

export default function RAWSPage(props) {
    const {
        raws,
        layers,
        setLayers
    } = useSensorDataContext();
    
    const {
        map, 
        setPanel
    } = props;

    const [columns, setColumns] = useState([]);

    const extractNumberFromString = (str) => {
        const match = str.match(/(\d+(\.\d+)?)/);
        
        if (match) {
          return parseFloat(match[0]);
        }
        return NaN;
    }

    const getDirection = (angle) => {
        var directions = ['North', 'NE', 'East', 'SE', 'South', 'SW', 'West', 'NW'];
        var index = Math.round(((angle %= 360) < 0 ? angle + 360 : angle) / 45) % 8;
        return directions[index];
    }

    useEffect(() => {
        if (raws) {
            setColumns( [
                {
                  field: 'location',
                  headerName: 'Location',
                  width: 170,
                  resizeable: false
                },
                {
                  field: 'temp',
                  headerName: 'Temperature',
                  width: 130,
                  resizeable: false
                },
                {
                  field: 'wind',
                  headerName: 'Wind Direction',
                  width: 110,
                  resizeable: false,
                  renderCell: (params) => (
                    <div
                    className='raws-page-content-wind-direction-title'>{getDirection(extractNumberFromString(params.row.wind))}
                    </div>
                  ),
                  cellClassName: 'raws-page-content-view-btn-container'
                },
                {
                  field: 'actions',
                  headerName: '',
                  flex: 1,
                  align: 'center',
                  resizeable: false,
                  renderCell: (params) => (
                    <div 
                    className='raws-page-content-view-btn-container-btn'
                    onClick={() => {
                        const station = raws.find((r) => r.id === params.row.id);
        
                        setPanel({
                            name: 'RAWS - Singular',
                            content: station
                        });

                        setLayers({
                            ...layers,
                            raws: true
                        });

                        const selected = map.current.getStyle().layers.filter((l) => l.id.includes('Layer-RAWS-symbol'))[0];
                        
                        map.current.setLayoutProperty(selected.id, 'visibility', 'visible');
                    
                        const location = [station.longitude, station.latitude];
                        map.current.flyTo({center: location, zoom: 17, pitch: 0, offset: [250, 0]});
                    }}>View</div>
                  ),
                  cellClassName: 'raws-page-content-view-btn-container'
                }
            ])
        }
    }, [raws])

    return (
        <div className='raws-page'>
            <div className='raws-page-title'>
                {/* <img className='raws-page-title-icon' src={rawsIcon}/> */}
                <div className='raws-page-title-text'>RAWS</div>
            </div>
            <div className='raws-page-description'>Remote Automated Weather Stations (RAWS) weather data provides real-time environmental information primarily used for fire weather monitoring and management.</div>
            {!raws 
            ?
            <>
                <br></br>
                <Spinner />
            </>
            :
            raws.length === 0
            ?
            <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: 'white', paddingTop: '0.5rem' }}>There are currently no RAWS.</div>
            :
            <div className='raws-page-content'>
                <DataGrid
                    rows={raws.map((r) => ({
                        id: r.id,
                        location: `${r.county ? r.county : 'N/A'}, ${r.state ? r.state : 'N/A'}`,
                        temp: r.airtempstandplace ? `${extractNumberFromString(r.airtempstandplace)}° F` : 'N/A',
                        wind: r.winddirdegrees ? r.winddirdegrees : 'N/A',
                    }))}
                    columns={columns}
                    sx={{
                        boxShadow: 'none',
                        fontFamily: "Avenir Next Regular",
                        fontWeight: 'bold',
                        border: 'none',
                        color: 'black',
                        borderColor: 'white',
                        '& .MuiDataGrid-scrollbarFiller': {
                            backgroundColor: 'rgb(223, 223, 223)'
                        },
                        '& .MuiCheckbox-root' : {
                            fontWeight: 'bold',
                            color: 'black',
                            filter: 'invert(100%)'
                        },
                        '& .MuiDataGrid-columnHeader' : {
                            color: 'black',
                            fontWeight: 'bold',
                            backgroundColor: 'rgb(223, 223, 223)',
                        },
                        '& .MuiDataGrid-footerContainer' : {
                            backgroundColor: 'rgb(223, 223, 223)'
                        },
                        '& .MuiTablePagination-displayedRows' : {
                            fontWeight: 'bold',
                            color: 'black'
                        },
                        '& .MuiTablePagination-root' : {
                            fontWeight: 'bold',
                            color: 'black'
                        },
                        '& .MuiSvgIcon-root' : {
                            filter: 'invert(100%)'
                        },
                        '& .Mui-disabled' : {
                            filter: 'invert(100%)'
                        },
                        '& .MuiTablePagination-actions' : {
                            filter: 'invert(100%)'
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            filter: 'invert(100%)'
                        }
                    }}
                    initialState={{
                    pagination: {
                        paginationModel: {
                        pageSize: 10,
                        },
                    },
                    }}
                    pageSizeOptions={[5]}
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                />
            </div>}
        </div>
    )
}